/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon16Regular = forwardRef('ArchiveCabinetIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.25 5A.75.75 0 0 1 6 4.25h3a.75.75 0 1 1 0 1.5H6A.75.75 0 0 1 5.25 5Z" }),
        React.createElement("path", { d: "M6 10.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 1A2.75 2.75 0 0 0 2 3.75v8.5A2.75 2.75 0 0 0 4.75 15h5.5A2.75 2.75 0 0 0 13 12.25v-8.5A2.75 2.75 0 0 0 10.25 1h-5.5ZM3.5 3.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v3.5h-8v-3.5Zm0 5v3.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3.5h-8Z" })));
});
